import _ from 'lodash';
import { sqConditionRuntimeStore } from '@/core/core.stores';
import { LIMIT_SIZE_1000 } from '@/main/app.constants';
import { isConditionMonitorNotificationsEnabled } from '@/services/systemConfiguration.utilities';
import { isCanceled } from '@/utilities/http.utilities';
import { logError } from '@/utilities/logger';
import { isPresentationWorkbookMode } from '@/utilities/workbookMode.utilities';
import {
  GetConditionMonitorMetadataListSortByEnum as SortByEnum,
  sqConditionMonitorsApi,
} from '@seeqdev/api/endpoint/ConditionMonitorsApi';

export async function fetchMonitoredConditionIds(conditionIds: string[]): Promise<void> {
  if (!isConditionMonitorNotificationsEnabled() || isPresentationWorkbookMode() || _.isEmpty(conditionIds)) {
    return;
  }

  try {
    const {
      data: { conditionMonitorMetadataList },
    } = await sqConditionMonitorsApi.getConditionMonitorMetadataList({
      conditionIds,
      sortBy: SortByEnum.Name,
      limit: LIMIT_SIZE_1000,
    });

    sqConditionRuntimeStore.actions.setMonitors({ conditionIds, conditionMonitorMetadataList });
  } catch (e) {
    if (!isCanceled(e)) {
      logError(_.toString(e));
    }
  }
}
